export default [
    {
        code: 'listside',
        name: 'List Side'
    },
    {
        code: 'buyside',
        name: 'Buy Side'
    }
];
export const STRIVE_ARCIMEDES_ROW_ID = 34